import { TYPES } from './mutations';
import api from './api';

const GENERIC_TYPES = {
  FETCH_PAYLOAD: 'payloadDetails',
  GET_QUOTE: 'quoteDetails',
  CREATE_ORDER: 'orderDetails',
  GET_OPEN_ENDED_TOKEN: 'openEndedTokenDetails',
  GET_INTERNAL_QUOTE: 'internalQuoteDetails',
  CREATE_GLOBAL_QUOTED_TICKETS: 'globalQuotedTicketsDetails',
  REMOVE_GLOBAL_QUOTED_TICKETS: 'globalQuotedTicketsDetails',
  REMOVE_ALL_GLOBAL_QUOTED_TICKETS: 'globalQuotedTicketsDetails',
  SAVE_USER_INFORMATION: 'globalQuotedTicketsDetails',
  VALIDATE_PCW_TOKEN: 'pcwTokenDetails',
};

function getPayloadToken({ commit }, { token }) {
  return new Promise(async (resolve, reject) => {
    commit(TYPES.GENERIC_REQUEST, GENERIC_TYPES.FETCH_PAYLOAD);
    try {
      const { data } = await api.getPayloadToken(token);
      commit(TYPES.FETCH_PAYLOAD_SUCCESS, data);
      resolve(data);
    } catch (error) {
      commit(TYPES.GENERIC_ERROR, {
        type: GENERIC_TYPES.FETCH_PAYLOAD,
        message: error.response.data.error.errors[0].message,
      });
      reject(error);
    }
  });
}

function getQuote({ commit }, { token, address }) {
  return new Promise(async (resolve, reject) => {
    commit(TYPES.GENERIC_REQUEST, GENERIC_TYPES.GET_QUOTE);
    try {
      const body = { address };
      const { data } = await api.getQuote(token, body);
      commit(TYPES.GET_QUOTE_SUCCESS, data);
      resolve(data);
    } catch (error) {
      commit(TYPES.GENERIC_ERROR, {
        type: GENERIC_TYPES.GET_QUOTE,
        message: error.response.data.error.errors[0].message,
      });
      reject(error);
    }
  });
}

function createOrder({ commit }, {
  token, address, card, first, last,
}) {
  return new Promise(async (resolve, reject) => {
    commit(TYPES.GENERIC_REQUEST, GENERIC_TYPES.CREATE_ORDER);
    try {
      const body = {
        address,
        card,
        first,
        last,
        token,
      };
      const { data } = await api.createOrder(token, body);
      commit(TYPES.CREATE_ORDER_SUCCESS, data);
      resolve(data);
    } catch (error) {
      commit(TYPES.GENERIC_ERROR, {
        type: GENERIC_TYPES.CREATE_ORDER,
        message: error.response.data.error.errors[0].message,
      });
      reject(error);
    }
  });
}

function getOpenEndedToken({ commit }, token) {
  return new Promise(async (resolve, reject) => {
    commit(TYPES.GENERIC_REQUEST, GENERIC_TYPES.GET_OPEN_ENDED_TOKEN);
    try {
      const { data } = await api.getOpenEndedToken(token);
      commit(TYPES.GET_OPEN_ENDED_TOKEN_SUCCESS, data);
      resolve(data);
    } catch (error) {
      commit(TYPES.GENERIC_ERROR, {
        type: GENERIC_TYPES.GET_OPEN_ENDED_TOKEN,
        message: error.response.data.error.errors[0].message,
      });
      reject(error);
    }
  });
}

function getInternalQuote({ commit }, body) {
  return new Promise(async (resolve, reject) => {
    commit(TYPES.GENERIC_REQUEST, GENERIC_TYPES.GET_INTERNAL_QUOTE);
    try {
      const { data } = await api.getInternalQuote(body);
      commit(TYPES.GET_INTERNAL_QUOTE_SUCCESS, data);
      resolve(data);
    } catch (error) {
      commit(TYPES.GENERIC_ERROR, {
        type: GENERIC_TYPES.GET_INTERNAL_QUOTE,
        message: error.response.data.error.errors[0].message,
      });
      reject(error);
    }
  });
}

function createGlobalQuotedTickets({ commit, state }, { id, quotedTickets, globalQuotedTickets }) {
  return new Promise(async (resolve, reject) => {
    commit(TYPES.GENERIC_REQUEST, GENERIC_TYPES.CREATE_GLOBAL_QUOTED_TICKETS);
    try {
      const data = {};
      data.quotedTickets = globalQuotedTickets;
      data.quotedTickets[id] = quotedTickets;
      const updateCount = state.globalQuotedTicketsDetails.count;
      data.count = updateCount + 1;
      commit(TYPES.CREATE_GLOBAL_QUOTED_TICKETS_SUCCESS, data);
      resolve(data);
    } catch (error) {
      commit(TYPES.GENERIC_ERROR, {
        type: GENERIC_TYPES.CREATE_GLOBAL_QUOTED_TICKETS,
        message: 'Something went wrong when updating the quoted tickets.',
      });
      reject(error);
    }
  });
}

function removeGlobalQuotedTickets({ commit, state }, { id, globalQuotedTickets }) {
  return new Promise(async (resolve, reject) => {
    commit(TYPES.GENERIC_REQUEST, GENERIC_TYPES.REMOVE_GLOBAL_QUOTED_TICKETS);
    try {
      const data = {};
      data.quotedTickets = globalQuotedTickets;
      delete data.quotedTickets[id];
      const updateCount = state.globalQuotedTicketsDetails.count;
      data.count = updateCount + 1;
      commit(TYPES.REMOVE_GLOBAL_QUOTED_TICKETS_SUCCESS, data);
      resolve(data);
    } catch (error) {
      commit(TYPES.GENERIC_ERROR, {
        type: GENERIC_TYPES.REMOVE_GLOBAL_QUOTED_TICKETS,
        message: 'Something went wrong when updating the quoted tickets.',
      });
      reject(error);
    }
  });
}

function removeAllGlobalQuotedTickets({ commit }) {
  return new Promise(async (resolve, reject) => {
    commit(TYPES.GENERIC_REQUEST, GENERIC_TYPES.REMOVE_ALL_GLOBAL_QUOTED_TICKETS);
    try {
      commit(TYPES.REMOVE_ALL_GLOBAL_QUOTED_TICKETS_SUCCESS);
      resolve();
    } catch (error) {
      commit(TYPES.GENERIC_ERROR, {
        type: GENERIC_TYPES.REMOVE_ALL_GLOBAL_QUOTED_TICKETS,
        message: 'Something went wrong when removing the quoted tickets.',
      });
      reject(error);
    }
  });
}

function saveUserInformation({ commit }, body) {
  return new Promise(async (resolve, reject) => {
    commit(TYPES.GENERIC_REQUEST, GENERIC_TYPES.SAVE_USER_INFORMATION);
    try {
      const data = body;
      commit(TYPES.SAVE_USER_INFORMATION_SUCCESS, data);
      resolve(data);
    } catch (error) {
      commit(TYPES.GENERIC_ERROR, {
        type: GENERIC_TYPES.SAVE_USER_INFORMATION,
        message: "Something went wrong when saving the user's information.",
      });
      reject(error);
    }
  });
}

function validatePCWToken({ commit }, body) {
  return new Promise(async (resolve, reject) => {
    commit(TYPES.GENERIC_REQUEST, GENERIC_TYPES.VALIDATE_PCW_TOKEN);
    try {
      const { data } = await api.validatePCWToken(body);
      commit(TYPES.VALIDATE_PCW_TOKEN_SUCCESS, data);
      resolve(data);
    } catch (error) {
      commit(TYPES.GENERIC_ERROR, {
        type: GENERIC_TYPES.VALIDATE_PCW_TOKEN,
        message: 'Invalid token',
      });
      reject(error);
    }
  });
}

export default {
  getPayloadToken,
  getQuote,
  createOrder,
  getOpenEndedToken,
  getInternalQuote,
  createGlobalQuotedTickets,
  removeGlobalQuotedTickets,
  removeAllGlobalQuotedTickets,
  saveUserInformation,
  validatePCWToken,
};
